import { EnergyType } from '../EnergyFlow'
import { InefficientProvider } from './common/InefficientProvider'
import { HourlyEnergyFlow } from '../HourlyEnergyFlow'

export class ElectricalGridProvider extends InefficientProvider {
  public readonly providedEnergyTypes = [EnergyType.Electricity]

  protected mapDemandToRequirementEnergyType(
    demand: HourlyEnergyFlow,
  ): EnergyType {
    return demand.energyType
  }

  protected mapDemandToWasteEnergyType(): EnergyType {
    return EnergyType.Heating
  }
}
